package com.kinoshazam.uiKit.theme

import androidx.compose.material3.Typography
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

//val Lato =
//    FontFamily(
//        Font(R.font.roboto_black, FontWeight.Black),
//        Font(R.font.roboto_bold, FontWeight.Bold),
//        Font(R.font.roboto_medium, FontWeight.Medium),
//        Font(R.font.roboto_regular, FontWeight.Normal),
//    )

val ExtraLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Normal,
        fontSize = 24.sp,
        lineHeight = 28.8.sp,
    )

val HardLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Normal,
        fontSize = 20.sp,
        lineHeight = 24.sp,
    )

val Large =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Normal,
        fontSize = 16.sp,
        lineHeight = 19.2.sp,
    )

val Medium =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Normal,
        fontSize = 14.sp,
        lineHeight = 16.8.sp,
    )

val Small =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Normal,
        fontSize = 12.sp,
        lineHeight = 14.4.sp,
    )

val MediumExtraLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Medium,
        fontSize = 24.sp,
        lineHeight = 28.8.sp,
    )

val MediumHardLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Medium,
        fontSize = 20.sp,
        lineHeight = 24.sp,
    )

val MediumLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Medium,
        fontSize = 16.sp,
        lineHeight = 19.2.sp,
    )

val MediumMedium =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Medium,
        fontSize = 14.sp,
        lineHeight = 16.8.sp,
    )

val MediumSmall =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Normal,
        fontSize = 12.sp,
        lineHeight = 14.4.sp,
    )

val BoldExtraLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Bold,
        fontSize = 24.sp,
        lineHeight = 28.8.sp,
    )

val BoldHardLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Bold,
        fontSize = 20.sp,
        lineHeight = 24.sp,
    )

val BoldLarge =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Bold,
        fontSize = 16.sp,
        lineHeight = 19.2.sp,
    )

val BoldMedium =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Bold,
        fontSize = 14.sp,
        lineHeight = 16.8.sp,
    )

val BoldSmall =
    TextStyle(
//        fontFamily = Lato,
        fontWeight = FontWeight.Bold,
        fontSize = 12.sp,
        lineHeight = 14.4.sp,
    )

//TODO: fix with designer
val typography =
    Typography(

        bodyLarge =
            TextStyle(
                fontFamily = FontFamily.Default,
                fontWeight = FontWeight.Normal,
                fontSize = 16.sp,
            ),
        bodyMedium =
            TextStyle(
//            fontFamily = Lato,
                fontWeight = FontWeight.Normal,
                fontSize = 14.sp,
                lineHeight = 18.sp,
            ),
        titleMedium = ExtraLarge,
        labelLarge =
            TextStyle(
                fontFamily = FontFamily.Default,
                fontWeight = FontWeight.W500,
                fontSize = 14.sp,
            ),
        labelMedium = Medium,
    )